"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _clientNode = require("./client-node");
var _clientBrowser = require("./client-browser");
var _request = require("./request");
var _utils = require("./utils");
Object.defineProperty(_request.Request, 'FormData', {
  get: function get() {
    return (0, _utils.getFormData)();
  },
  set: function set(value) {
    (0, _utils.setFormData)(value);
  }
});
_request.Request.XMLHttpRequest = typeof XMLHttpRequest !== 'undefined' ? XMLHttpRequest : undefined;

// `tlsOptions` is meaningful for the Node client only, XMLHttpRequest gives no control over the
// client certificate - a browser picks it from the OS/browser keystore when a server asks for one
_request.Request.send = function (path, method, headers, body, encoding, timeout, withCredentials, tlsOptions) {
  var sender = typeof _request.Request.XMLHttpRequest !== 'undefined' ? _clientBrowser.sendXmlHttpRequest : _clientNode.sendNodeAPIRequest;
  return sender(path, method, headers, body, encoding, timeout, withCredentials, tlsOptions);
};
_request.Request.verbose = false;
_request.Request.withCredentials = false;
_request.Request.methods = ['get', 'post', 'put', 'patch', 'delete', 'head', 'options'];
_request.Request.methods.forEach(function (method) {
  _request.Request[method] = function (path, body) {
    return new _request.Request(path, method, body);
  };
});
exports = module.exports = _request.Request;
var _default = exports["default"] = _request.Request;